import { addBreadcrumb, captureException } from '@sentry/browser'
import { flatten, isValiError } from 'valibot'
import { useAuthPlayerIdSignal } from '../../../../rx/signal/useAuthPlayerIdSignal'
import { useActionLogsSignal } from '../../../../rx/signal/useActionLogsSignal'
import { setAlertBagError } from '../../../../rx/store/AlertBag'
import { getEngineAlertBag } from '../../../three/fn/getSetEngineAlertBag'
import { getEngineToast } from '../../../three/fn/getSetEngineToast'
import { Engine } from '../../engine/Engine.type'
import Action from './action/Action.type'
import type { ActionLog } from './ActionLog.type'
import applyActionWithWasm from './applyActionWithWasm'

// let lastClientDispatch: Promise<unknown> | null = null
export default async function dispatchReplay(engine: Engine, action: Action, cref: number): Promise<void> {
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)
  const [getActionLogs, setActionLogs] = useActionLogsSignal(engine)
  // console.log('dispatchReplay', {
  //   authPlayerId: getAuthPlayerId(),
  //   players: engine.state.players.map((p) => ({
  //     player_id: p.id,
  //     profile_id: p.profile_id,
  //   }))
  // })

  const toast = getEngineToast(engine)
  const ab = getEngineAlertBag(engine)

  addBreadcrumb({
    category: 'action',
    level: 'info',
    data: {
      action,
    },
  })
  // if (isServer) {
  //   throw new Error('dispatchReplay is only available on the client')
  // }
  try {
    const { state : { round } } = engine

    const actionLog : ActionLog = {
      cref,
      round,
      player_id: getAuthPlayerId(),
      at: Date.now(),
      action,
    }

    await applyActionWithWasm(engine, action)

    setActionLogs([...getActionLogs(), actionLog])
  } catch (err) {
    const msg: string = (err as { message?: string }).message || 'unknown'
    const context: Record<string, unknown> = {
      action,
    }
    if (isValiError(err)) {
      context.errors = flatten(err.issues)
    }
    const err2 = new Error(`Action Failed: ${msg}`, { cause: err })
    console.error(err, context)
    captureException(err, context)
    if (toast) {
      toast.error(msg)
    }
    if (ab) {
      setAlertBagError(ab, err2)
    }
    throw err2
  }
}
